import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isHeader"];
import React, { forwardRef } from 'react';
import Box from 'components/Box';
import { useTableContext } from './TableContext';
import TableCell from './TableCell';
import { Wrapper as ColumnHeaderCell } from './TableColumnHeader';
var TableCheckboxCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isHeader = _ref.isHeader,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTableContext = useTableContext(),
    mobileViewBreakpoint = _useTableContext.mobileViewBreakpoint;
  if (isHeader) {
    return /*#__PURE__*/React.createElement(ColumnHeaderCell, _extends({}, otherProps, {
      isCheckbox: true,
      ref: ref,
      scope: "col",
      width: 20
    }), /*#__PURE__*/React.createElement(Box, {
      display: "flex"
    }, children));
  }
  return /*#__PURE__*/React.createElement(TableCell, _extends({
    isCheckbox: true
  }, otherProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: ['top', 'center'],
    height: "100%",
    breakpoints: mobileViewBreakpoint
  }, children));
});
TableCheckboxCell.displayName = 'TableCheckboxCell';
export default TableCheckboxCell;